import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusValueDcFeature } from '@vi-iot/client';

import { NO_VALUE } from '@pipes';
import { ERROR_CONNECTION_STATUS } from '../../operational-data-common/translations';

@Injectable({
  providedIn: 'root',
})
export class FeatureConnectionService {
  constructor(private translateService: TranslateService) {}

  isErrorOrNotConnectedBasedOnTranslation(value: string): boolean {
    return Object.values(ERROR_CONNECTION_STATUS).some(
      (translationKey) => value === this.translateService.instant(translationKey)
    );
  }

  isErrorOrNotConnectedBasedOnValue(status: string | undefined): boolean {
    if (typeof status !== 'string') {
      return false;
    }

    const statusLowercase = status.toLowerCase();

    return (
      statusLowercase === StatusValueDcFeature.error.toLowerCase() ||
      statusLowercase === StatusValueDcFeature.notConnected.toLowerCase()
    );
  }

  getTranslatedFeatureStatus(status: string, noValueString?: string): string {
    if (typeof status !== 'string') {
      return noValueString ?? NO_VALUE;
    }

    const statusLowercase = status.toLowerCase();

    if (statusLowercase === StatusValueDcFeature.error.toLowerCase()) {
      return this.translateService.instant(ERROR_CONNECTION_STATUS[StatusValueDcFeature.error]);
    }

    if (statusLowercase === StatusValueDcFeature.notConnected.toLowerCase()) {
      return this.translateService.instant(
        ERROR_CONNECTION_STATUS[StatusValueDcFeature.notConnected]
      );
    }

    return noValueString ?? NO_VALUE;
  }
}
